import React, { useEffect, useState } from 'react';
import { get, find } from 'lodash';
import { connect } from 'react-redux';
import { toggleOption } from '../store/actions';
import { Routes, Route, useNavigate } from 'react-router-dom';
import OptionDetails from './optionDetails/OptionDetails';
import PackageDetails from '../steps/packages/PackageDetails';

const OptionsPage = (props) => {
  const [selectingOption, setSelectingOption] = useState(null);
  const { children, onChange, options, isUpdating, moreOptions } = props;

  useEffect(() => {
    if (!isUpdating) {
      setSelectingOption(null);
    }
  }, [isUpdating]);

  const navigate = useNavigate();

  const onSelect = (option) => {
    setSelectingOption(option);
  };

  const onDetails = (option) => {
    const path = option.packageOption ? 'package' : 'option';
    navigate(`${path}/${option.code}`);
  };

  const onDetailsClose = () => {
    navigate('');
  };

  const onDetailsSelect = (option) => {
    navigate('');
    onSelect(option);
  };

  useEffect(() => {
    if (selectingOption) {
      onChange(selectingOption);
    }
  }, [selectingOption]);

  return (
    <>
      {children({
        onChange: onSelect,
        onDetails,
        isUpdating,
        selectingOption,
      })}
      <Routes>
        <Route
          path={`/option/:id`}
          element={
            <OptionDetails
              options={options}
              onClose={onDetailsClose}
              onSelect={onDetailsSelect}
              showImageDisclosure
              moreOptions={moreOptions}
            />
          }
        />
        <Route
          path="/package/:id"
          element={
            <OptionDetails
              type="package"
              options={options}
              onClose={onDetailsClose}
              onSelect={onDetailsSelect}>
              <PackageDetails packages={options} />
            </OptionDetails>
          }
        />
      </Routes>
    </>
  );
};

const mapStateToProps = (state) => {
  const { options, summary } = state.config;
  return {
    options,
    moreOptions: get(find(summary?.options, { key: 'options' }), 'options'),
    isUpdating: state.isUpdating,
  };
};

const mapDispatchToProps = (dispatch) => {
  const onChange = (option) => {
    dispatch(toggleOption(option));
  };

  return {
    onChange,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OptionsPage);
